import { BLANK_VALUE } from 'modules/Monitoring/consts/ui'

export const formatBlankLabel = (label: string, value?: string) =>
  (value ?? label) === BLANK_VALUE ? 'Not specified' : label
